var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTimeline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "23px",
    viewBox: "0 0 42 23",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "05FAD165-3F53-456E-A507-F8A98AA8524D")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-1069.000000, -556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy-3",
    transform: "translate(598.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(172.100000, 66.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Action-/-timeline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-timeline"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.125,15 C43.125,17.0625 41.4375,18.75 39.375,18.75 C39.0375,18.75 38.71875,18.7125 38.41875,18.61875 L31.74375,25.275 C31.8375,25.575 31.875,25.9125 31.875,26.25 C31.875,28.3125 30.1875,30 28.125,30 C26.0625,30 24.375,28.3125 24.375,26.25 C24.375,25.9125 24.4125,25.575 24.50625,25.275 L19.725,20.49375 C19.425,20.5875 19.0875,20.625 18.75,20.625 C18.4125,20.625 18.075,20.5875 17.775,20.49375 L9.24375,29.04375 C9.3375,29.34375 9.375,29.6625 9.375,30 C9.375,32.0625 7.6875,33.75 5.625,33.75 C3.5625,33.75 1.875,32.0625 1.875,30 C1.875,27.9375 3.5625,26.25 5.625,26.25 C5.9625,26.25 6.28125,26.2875 6.58125,26.38125 L15.13125,17.85 C15.0375,17.55 15,17.2125 15,16.875 C15,14.8125 16.6875,13.125 18.75,13.125 C20.8125,13.125 22.5,14.8125 22.5,16.875 C22.5,17.2125 22.4625,17.55 22.36875,17.85 L27.15,22.63125 C27.45,22.5375 27.7875,22.5 28.125,22.5 C28.4625,22.5 28.8,22.5375 29.1,22.63125 L35.75625,15.95625 C35.6625,15.65625 35.625,15.3375 35.625,15 C35.625,12.9375 37.3125,11.25 39.375,11.25 C41.4375,11.25 43.125,12.9375 43.125,15 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimeline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timeline.11637a24.svg";
export { ForwardRef as ReactComponent };